const apiURL = require('./apiURL');
// const apiURL = `http://localhost:3000`;

// types of action
const Types = {
  QUIZ_ANSWER: "QUIZ_ANSWER",
  QUIZ_INDEX: "QUIZ_INDEX",
};

const saveAnswer = (questionIndex, answer, question) => ({
  type: Types.QUIZ_ANSWER,
  questionIndex, 
  answer,
  question,
});

const setNextQuestionIndex = index => ({
  type: Types.QUIZ_INDEX,
  index
});

const restartQuiz = () => {
  return (dispatch, getState) => {
    dispatch(setNextQuestionIndex(0))
  }
}

const nextQuestion = ({
  arn,
  name,
}) => {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(setNextQuestionIndex((state.quiz.index ?? 0) + 1))
  }
}

const previousQuestion = ({
  arn,
  name,
}) => {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(setNextQuestionIndex(Math.min((state.quiz.index ?? 0) - 1),0))
  }
}


const Actions = {
  saveAnswer,
  nextQuestion,
  restartQuiz
};


export {Types, Actions}